var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import axios from "axios";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
import moment from "moment/moment";
import { router } from '@inertiajs/react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { PencilIcon } from "@heroicons/react/24/outline";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
export default function BookingEditButton(_a) {
    var team = _a.team, appointment = _a.appointment, calendar = _a.calendar;
    var route = useRoute(Ziggy);
    var _b = useState({}), slotsByDate = _b[0], setSlotsByDate = _b[1];
    var toast = useToast().toast;
    var _c = useState(appointment.start_date), date = _c[0], setDate = _c[1];
    var _d = useState(0), step = _d[0], setStep = _d[1];
    var _e = useState(appointment.start_date), slot = _e[0], setSlot = _e[1];
    var _f = useState(false), submitting = _f[0], setSubmitting = _f[1];
    // const formSchema = z.object({
    //     email: z.string().min(2).max(255),
    //     name: z.string().min(2).max(255),
    //     telephone: z.string().min(2).max(255),
    //     accept_terms: z.boolean(),
    // })
    // const form = useForm<z.infer<typeof formSchema>>({
    //     resolver: zodResolver(formSchema),
    //     defaultValues: {
    //         email: appointment.client.email,
    //         name: appointment.client.name,
    //         telephone: appointment.client.telephone,
    //         accept_terms: false,
    //     },
    // })
    function submit() {
        setSubmitting(true);
        axios.put(route('appointments.update', { team: team, appointment: appointment }), {
            date: moment(slot.start_date).format("YYYY-MM-DD HH:mm"),
            // name: form.getValues().name,
            // email: form.getValues().email,
            // telephone: form.getValues().telephone,
            // booking_slot_uuid: slot.booking_slot_uuid,
        }).then(function (response) {
            // setStep(3);
            var toastOpts = {
                title: "Appointment updated",
            };
            toast(toastOpts);
            setIsOpen(false);
            setSubmitting(false);
            router.reload();
        }, function (error) {
            alert("An unexpected error has occurred");
        });
    }
    function onOpenChange(open) {
        if (open) {
            setIsOpen(true);
        }
        else {
            setIsOpen(false);
        }
    }
    var _g = useState(false), isOpen = _g[0], setIsOpen = _g[1];
    useEffect(function () {
        if (isOpen) {
            axios.get(route('frontend.booking.slots', {
                calendar: calendar.id,
                startDate: moment().format("YYYY-MM-DD")
            })).then(function (response) {
                setSlotsByDate(response.data.slotsByDate);
                setDate(new Date(appointment.start_date));
                setSlot(response.data.slotsByDate[appointment.start_date.substring(0, 10)].find(function (slot) {
                    // console.log("slot.start_date == appointment.start_date", slot.start_date, appointment.start_date);
                    return slot.start_date == appointment.start_date;
                }));
            });
        }
    }, [isOpen]);
    return (_jsxs(Dialog, __assign({ open: isOpen, onOpenChange: onOpenChange }, { children: [_jsx(DialogTrigger, __assign({ asChild: true }, { children: _jsx("button", __assign({ onClick: function () {
                    }, className: "text-gray-600 hover:text-gray-900 ml-2" }, { children: _jsx(PencilIcon, { className: "inline-block w-3 h-3" }) })) })), _jsxs(DialogContent, __assign({ onPointerDownOutside: function (e) { return e.preventDefault(); }, className: "sm:max-w-md" }, { children: [_jsxs(DialogHeader, { children: [_jsx(DialogTitle, { children: "Book an appointment" }), _jsx(DialogDescription, { children: "Book an appointment" })] }), slotsByDate && slotsByDate[moment(date).format("YYYY-MM-DD")] && _jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsxs("div", __assign({ className: "flex" }, { children: [_jsxs("div", { children: [_jsx("div", __assign({ className: "mb-2" }, { children: "Date" })), _jsx(Calendar, { mode: "single", selected: date, onSelect: function (date) {
                                                    setDate(date);
                                                    setStep(1);
                                                }, className: "rounded-md border", disabled: function (date) {
                                                    return date < new Date() || Object.keys(slotsByDate).indexOf(moment(date).format("YYYY-MM-DD")) == -1;
                                                } })] }), date && _jsxs("div", __assign({ className: "ml-4" }, { children: [_jsx("div", __assign({ className: "mb-2" }, { children: "Times" })), _jsx("div", __assign({ className: "flex flex-col gap-2" }, { children: slotsByDate[moment(date).format("YYYY-MM-DD")].map(function (_slot, idx) {
                                                    return _jsx("div", { children: _jsx(Button, __assign({ size: "sm", variant: "".concat(_slot.start_date === (slot === null || slot === void 0 ? void 0 : slot.start_date) ? "default" : "outline"), disabled: _slot.disabled, onClick: function () {
                                                                setSlot(_slot);
                                                                setStep(2);
                                                            } }, { children: moment(_slot.start_date).format("HH:mm") })) }, idx);
                                                }) }))] }))] })), date && slot && _jsxs("div", __assign({ className: "border-b pb-4 mb-4" }, { children: [_jsx("div", __assign({ className: "mr-2" }, { children: "Date:" })), _jsx("strong", { children: moment(slot.start_date).format("HH:mm, dddd, D MMMM YYYY") })] })), _jsx(Button, __assign({ onClick: submit, type: "submit", disabled: submitting }, { children: "Submit" }))] }))] }))] })));
}
